import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

import type {
  AccessorialQuestionBubble,
  LocationsAccessorialQuestionBubbleProps,
} from "../Types/LocationsAccessorialQuestionBubbleTypes";
import { describeLocationContext } from "@/Helpers/describeLocationContext";

const LocationsAppointmentRequiredQuestionBubble: AccessorialQuestionBubble = (
  props: LocationsAccessorialQuestionBubbleProps,
) => {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            {`Delivery appointment required at ${describeLocationContext(props.locationContext)}`}
          </T>
          <T size="xs" color="secondary">
            {`Check this box if you need the carrier to deliver within a specific time window or two hours or less. They will contact the delivery contact to confirm the time.`}
          </T>
          <T weight="bold">
            {`Please note - if the delivery contact requests a delivery appointment that is a significant number of days after the freight arrives at the delivery terminal, storage fees may apply.`}
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/special-services/delivery-appointments"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LocationsAppointmentRequiredQuestionBubble;
